import React, {Component} from 'react'
import { getEmailTextByCountryCode } from '../../../../../panel-admin/common/functions/emailPreviewText'
import { getSubCommunities,getSelectedSubCommunity, getMessagesLanguageCodeBySubCommunity, getCurrentCountryCode } from '../../../../../panel-admin/common/functions/countrySetting'
import {Link} from 'react-router-dom'
import '../../../../../css/elements/logo.css'


class EmailPreview extends Component{

  render(){
    let emailText='';
    let currentCountryCode = '';
    if(getSubCommunities() != '' && getSelectedSubCommunity()){
      emailText = getEmailTextByCountryCode(getMessagesLanguageCodeBySubCommunity())
      currentCountryCode = getCurrentCountryCode();
    }else{
      emailText = getEmailTextByCountryCode();
    }

    let recipientNameArr = this.props.recipients.split(" ")

    return(
      <div className="container-preview">
        <div className="email-preview">
          <p className="email-preview-subject">
            {this.props.subject}
          </p>
          <p>
            {emailText.fraseFirst}
            {recipientNameArr[0] == 'Talents' && <span style={{backgroundColor:"#F8DE7E"}}>first name</span>}
            {recipientNameArr.length > 3 && recipientNameArr[0] != 'Talents' && <span style={{backgroundColor:"#F8DE7E"}}>first name</span>}
            {<span>{recipientNameArr.length == 3 && recipientNameArr[0]}</span>}
            {emailText.countryCode == "pl"? "!":""}
          </p>
          <p>
            {this.props.content}
          </p>
          <p>
            {emailText.fraseSecond}
            <br />
            {emailText.fraseThird}
          </p>
          <p className="email-preview-logo">
            <img src="/assets/images/produb_logo_small_direct_your_way.png" alt="" />
          </p>
          <p className="email-preview-footer">
            {emailText.footer1}
            <br />
            {currentCountryCode?
            <a target="_blank" href={'https://' + currentCountryCode + '.produb.app'}>{'https://' + currentCountryCode + '.produb.app'}</a>
            :
            <a target="_blank" href={'https://' + emailText.countryCode + '.produb.app'}>{'https://' + emailText.countryCode + '.produb.app'}</a>
            }
            <br />
            {emailText.footer2}
          </p>
          <p className="email-preview-footer">
            {emailText.footer3}
            <br />
            {emailText.footer4}
            {currentCountryCode?
            <a href={"mailto:support-" + currentCountryCode + '@produb.app'}>{"support-" + currentCountryCode + '@produb.app'}</a>
            :
            <a href={"mailto:support-" + emailText.countryCode + '@produb.app'}>{"support-" + emailText.countryCode + '@produb.app'}</a>
          }
            {emailText.countryCode == 'kr' || emailText.countryCode == 'in' || emailText.countryCode == 'hu' ? ' ' + emailText.footer4a : ''}
          </p>
        </div>
        <img src="/assets/images/mobileEmpty.png"  alt="" />
      </div>
    )
  }
}

export default (EmailPreview)
